// src/components/Footer.jsx
import React from 'react';
import './Footer.css';
import { FaFacebookF, FaInstagram, FaYoutube, FaWhatsapp, FaTiktok, FaEnvelope } from 'react-icons/fa'; // Íconos de redes sociales y correo

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Información de copyright */}
       <p>© 2026 Desarollado por Crygtec. Todos los derechos reservados.  
        Licenciado exclusivamente para MS Group_Constructora (RUC: 20613385135).  
        Prohibida la reproducción total o parcial del software sin autorización expresa de Crygtec_Y.V.R.</p>
        
        {/* Enlaces a redes sociales */}
        <div className="social-links">
          <a href="https://www.facebook.com/share/y1wwrzsQA1wZcmmp/" target="_blank" rel="noopener noreferrer">
            <FaFacebookF className="social-icon" />
          </a>
          <a href="https://www.instagram.com/msgroup_constructora/profilecard/?igsh=c3ljeDFzc3JpdWV6" target="_blank" rel="noopener noreferrer">
            <FaInstagram className="social-icon" />
          </a>
          <a href="https://www.youtube.com/@MSGROUPSAC" target="_blank" rel="noopener noreferrer">
            <FaYoutube className="social-icon" />
          </a>
          <a href="https://walink.co/04086c" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp className="social-icon" />
          </a>
          <a href="https://www.tiktok.com/@msgroup.sac" target="_blank" rel="noopener noreferrer">
            <FaTiktok className="social-icon" />
          </a>
          <a href="mailto:msgroupsac16@gmail.com" target="_blank" rel="noopener noreferrer">
            <FaEnvelope className="social-icon" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
